import {
    ApiHandlerDiscreteParameter,
    executeAwaitableHandlerChain,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { chain, SignIn } from "@insite/client-framework/Store/Pages/SignIn/Handlers/SignInAsGuest";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

type SignInAsGuestParameter = {
    returnUrl: string;
};

type HandlerType = ApiHandlerDiscreteParameter<
    SignInAsGuestParameter,
    Partial<AccountModel>,
    ServiceResult<AccountModel>
>;

export const CustomSignInWithAwait: HandlerType = async props => {
    if (!props.apiResult.successful) {
        throw new Error(`There was an issue signing in as a guest: ${props.apiResult.errorMessage}`);
    }
    const { userName, password } = props.apiResult.result;
    const { returnUrl } = props.parameter;
    await executeAwaitableHandlerChain(
        signIn,
        {
            userName,
            password,
            rememberMe: false,
            returnUrl,
        },
        props,
    );
};

replaceInChain(chain, SignIn, CustomSignInWithAwait);
